import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
declare var $:any

@Directive({
  selector: '[appCloseDropdown]'
})
export class CloseDropdownDirective {

  constructor(private _elementRef : ElementRef) {
  }

  @Output() public clickOutside = new EventEmitter();

  
@HostListener('document:click', ['$event.target'])
public onClick(targetElement) {
  const isClickedInside = this._elementRef.nativeElement.contains(targetElement);
  if(!targetElement.classList.contains('notToClose')){
    $('.dropdown-content').removeClass("show");
    $('.dropdown-content').removeAttr('style');
    $('.showmoredrp').removeAttr('style');
    $('.drop_down_tenant,.showmoredrp').removeClass("show");
    $('#drop_down_payment').css("display","none");

    setTimeout(() => {
      $('.note-hint-popover').css("display", "none")
    }, 100)
   
  }else if(targetElement.classList.contains('notToClose')){
   
  }
  
}

}
